document.addEventListener('DOMContentLoaded', function() {
    var menuToggle = document.getElementById('menuOpen');
    var menuClose = document.getElementById('menuClose');
    var dropmenu = document.getElementById('dropmenu');
    // Otwieranie menu
    if (menuOpen) menuToggle.addEventListener('click', function() {
        dropmenu.classList.add('active');
        document.body.style.overflow = 'hidden'; // Zablokuj przewijanie strony
    });
    // Zamykanie menu
    if (menuClose) menuClose.addEventListener('click', function() {
        dropmenu.classList.remove('active');
        document.body.style.overflow = ''; // Odblokuj przewijanie strony
    });
    // Zamykanie menu po kliknięciu na link
    var menuLinks = dropmenu.querySelectorAll('a');
    menuLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            dropmenu.classList.remove('active');
            document.body.style.overflow = '';
        });
    });
    // Zamykanie menu po kliknięciu poza nim
    dropmenu.addEventListener('click', function(e) {
        if (e.target === dropmenu) {
            dropmenu.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
});

//# sourceMappingURL=Kickstarter.fb5ed782.js.map
